module.exports = __webpack_public_path__ + "img/S2M1_new.5015571a.jpg";